import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
export default class Card extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "interactive", void 0);
  }
}
__decorate([Prop({
  default: false
})], Card.prototype, "interactive", void 0);